import { render, staticRenderFns } from "./tipDialog.vue?vue&type=template&id=caf68d4e&scoped=true"
import script from "./tipDialog.vue?vue&type=script&lang=js"
export * from "./tipDialog.vue?vue&type=script&lang=js"
import style0 from "./tipDialog.vue?vue&type=style&index=0&id=caf68d4e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf68d4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caf68d4e')) {
      api.createRecord('caf68d4e', component.options)
    } else {
      api.reload('caf68d4e', component.options)
    }
    module.hot.accept("./tipDialog.vue?vue&type=template&id=caf68d4e&scoped=true", function () {
      api.rerender('caf68d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/components/tipDialog.vue"
export default component.exports